import { API_BASE_URL } from '@/config/env'

export function resolveSocketBaseUrl(apiBaseUrl = API_BASE_URL) {
  if (!apiBaseUrl) {
    return null
  }

  const host = apiBaseUrl.replace(/\/api\/?$/i, '')
  return new URL(host || '/', window.location.origin).origin
}
